import React, { Fragment } from 'react'
import './about.css'

const About = (props) => {
  return (
    <div className="about-container">
      <div className='about-header flex'>
        <div className='container mx-auto px-4 py-4 flex justify-between items-center'>
          <span className='font-semibold text-lg text-white'>About us</span>
          <button 
            onClick={() => {
              // Close the modal if props.close exists
              if (props.close) props.close();
          
              // DOM manipulation to update classes
              const aboutUsElement = document.querySelector('nav .about-us');
              const homeElement = document.querySelector('nav .home');
          
              if (aboutUsElement) aboutUsElement.classList.remove('selected');
              if (homeElement) homeElement.classList.add('selected');
            }}
          >
            <img className="ml-auto" src="images/close.svg" alt="ITEnterprise Logo" width={28} height={28} />
          </button>
        </div>
      </div>
      <section className="about-content relative">
        <div className="container mx-auto px-4">
          <div className='lg:p-8 md:p-6 p-6'>
            <img src="images/dopo-logo.svg" alt="Dopo Logo" width={147} height={82} className="mb-8" />
            <h1 className="text-3xl text-gray-800 leading-tight font-bold text-white">
              We are an IT Infrastructure<br/> Management Company
            </h1>
            <p className="mt-4 md:mt-6 lg:mt-6 text-base service-para-color" style={{width: "80%"}}>
              We are an IT infrastructure management company providing products, solutions, and services to simplify complex IT environments. Dopo Infosystems solves business challenges with tailored IT services, delivering high returns through innovation and a customer-first approach. Our partnerships with Dell, HP, Cisco, and Microsoft, along with certified experts, ensure exceptional value and reliability.
            </p>
          </div>
        </div>
        <div className="container mx-auto px-4 lg:p-8 md:p-6 p-6 clearfix relative" style={{zIndex: 100}}>
          <img src="images/durairaj.png" alt="About Image" className="lg:float-left md:float-left float-none mr-64 ml-2" width={300} />
          <div className='intro'>
            <h1 className="text-3xl text-gray-800 leading-tight font-bold text-white">Mr Durairaj.S</h1>
            <p className='text-xl mt-2'>Managing Director</p>
            <p className='mt-8 mb-8' style={{width: "80%"}}>With over 15 years of experience in IT Infrastructure industry, Durairaj. S is an accomplished veteran in IT services business. He has previously worked for CMC and brings to the table, hands-on experience in building IT Infrastructure Solutions.</p>
            <div className='flex exp'>
              <div>
                <h2>20+</h2>
                <p>Years Experience</p>
              </div>
              <div>
                <h2>53+</h2>
                <p>Projects</p>
              </div>
              <div>
                <h2>35+</h2>
                <p>Clients</p>
              </div>
            </div>
          </div>
        </div>
        <div className='about-bg hidden md:flex'></div>
      </section>
    </div>
  )
}

export default About;
